export function createSearchParams(debugParams?: Record<string, unknown>) {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(debugParams ?? {})) {
    if (typeof value === 'string') {
      params.set(key, value);
    } else if (Array.isArray(value)) {
      params.set(key, value.map(String).join(','));
    } else if (typeof value === 'number') {
      params.set(key, String(value));
    } else if (typeof value === 'boolean') {
      params.set(key, String(value));
    } else if (value === null) {
      // do nothing
    } else if (value === undefined) {
      // do nothing
    } else if (typeof value === 'object') {
      try {
        params.set(key, JSON.stringify(value));
      } catch (error) {
        console.error('Error serializing object to JSON:', error);
      }
    }
  }

  return params;
}
